import React from 'react';
import { EditorSystem } from '../../../systems/editor/EditorSystem';
import { useTeleporterState } from './teleporter/useTeleporterState';
import { TeleporterHeader, TeleporterList, TeleporterForm } from './teleporter/TeleporterUI';

interface TeleporterConfigProps {
  editorSystem: EditorSystem | null;
}

export const TeleporterConfig: React.FC<TeleporterConfigProps> = ({ editorSystem }) => {
  const { state, actions } = useTeleporterState(editorSystem);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', pointerEvents: 'auto' }}>
      <div style={{
        backgroundColor: '#34495e',
        borderLeft: '1px solid #2c3e50',
        borderRight: '1px solid #2c3e50',
        color: 'white',
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '8px',
        boxSizing: 'border-box'
      }}>
        <TeleporterHeader
          showLinkLines={state.showLinkLines}
          setShowLinkLines={actions.setShowLinkLines}
          linkColor={state.linkColor}
          setLinkColor={actions.setLinkColor}
          linkedCount={state.linkedTeleporters.length}
          totalCount={state.teleporters.length}
          selectedTeleporterId={state.selectedTeleporterId}
          editorSystem={editorSystem}
          handleDeleteTeleporter={actions.handleDeleteTeleporter}
        />

        <TeleporterList
          teleporters={state.teleporters}
          selectedTeleporterId={state.selectedTeleporterId}
          setSelectedTeleporterId={actions.setSelectedTeleporterId}
        />

        {state.selectedTeleporterId ? (
          <TeleporterForm
            state={state}
            actions={actions}
            editorSystem={editorSystem}
          />
        ) : (
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.5,
            padding: '20px',
            textAlign: 'center'
          }}>
            <div>
              <div style={{ fontSize: '24px', marginBottom: '10px' }}>⬌</div>
              <div style={{ fontSize: '12px' }}>
                Select a teleporter from the list above to configure its link
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeleporterConfig;
